const serviceCreationBlockedModal = {
  title: 'Criação de serviço bloqueada',
  text: 'A criação de serviço só está disponível escaneando o QRCODE do equipamento no App',
  okButton: 'Ok',
};

export default serviceCreationBlockedModal;
